<template>
  <div>   
    <embed
      src="https://tpsql.transplus.ca/REPORTFILES/Pages/ReportViewer.aspx?%2fWAREHOUSE%2fWHSE_SPACE_V3&rs:Command=Render"
      style="width:100%; height:calc(100vh - 76px) ;margin-top:76px; display: block;overflow: auto;"
    >
  </div>
</template>

<script>
  export default {}
</script>

<style>

</style>
